import { useQueryErrorResetBoundary } from '@tanstack/react-query';
import { useRouter } from '@tanstack/react-router';
import { usePostHog } from 'posthog-js/react';
import { useEffect } from 'react';

import { resolveChunkLoadRecovery } from './chunk-load-recovery.js';
import { ErrorBoundaryRender } from './error-boundary-render.js';
import { GenericErrorBoundaryRender } from './generic-error-boundary-render.js';

import type { ErrorComponentProps } from '@tanstack/react-router';

export function RouterErrorBoundary({ error }: ErrorComponentProps) {
	const router = useRouter();
	const queryErrorResetBoundary = useQueryErrorResetBoundary();
	const posthog = usePostHog();

	useEffect(() => {
		queryErrorResetBoundary.reset();
	}, [queryErrorResetBoundary]);

	useEffect(() => {
		posthog.captureException(error, { chunk_load_recovery: resolveChunkLoadRecovery(error) });
	}, [error, posthog]);

	const handleManualReset = () => {
		router.invalidate().catch((error: unknown) => {
			throw error;
		});
	};

	return (
		<ErrorBoundaryRender
			error={error}
			renderUnknownError={() => (
				<GenericErrorBoundaryRender buttonText='Reload' error={error} onButtonClick={handleManualReset} />
			)}
		/>
	);
}
